<main>

    <section class="section-header">
        <div class="img-container">
            <img class="bg" *ngIf="imageUrl" [ngSrc]="imageUrl" alt="Comunidad Futuro" width="1920" height="400" priority >
            <div class="container-overlay">
                <div class="container">
                    <div class="logo">
                        <figure class="header-logo">
                            <a href="https://www.futurocasadevalores.com/" target="_blank" title="Comunidad Futuro">
                                <img src="assets/images/comunidad-futuro.svg" alt="Comunidad Futuro" loading="eager" width="205" height="53">
                            </a>
                        </figure>
                    </div>
                    <div class="row d-flex">
                        <div class="col-md-12">
                            <div class="container-header">
                                <h1>
                                    Alcanza tus metas financieras<br>
                                    <span>con el respaldo de expertos</span>
                                </h1>
                                <p>
                                    Accede a beneficios exclusivos y vive la <br>experiencia Premium
                                </p>
                
                                <button (click)="goToLink()" class="custom-button-tertiary ">
                                    <span>
                                        ¡Empieza tu membresía Premium!
                                    </span>
                                    <div class="box-icon">
                                        <img src="assets/images/icons/crown-md.png" alt="arrow right" width="20" height="20">
                                    </div>
                                </button>
                            </div>
                        
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="box">
            <div class="container">
                <div class="row">
                    <p>Sé parte de la comunidad de inversionistas más grande del Ecuador </p>
                    <h2>
                        <!-- <img src="assets/images/icons/fluent-premium-filled.webp" alt="arrow right" width="30" height="30"> <span>8.<span class="decimal">00</span></span> <small>Mens.</small> -->
                        por&nbsp;<span class="precio">$ 0.30 centavos diarios</span>&nbsp;puedes obtener
                    </h2>
                    <h2>
                        <!-- <img src="assets/images/icons/fluent-premium-filled.webp" alt="arrow right" width="30" height="30"> <span>8.<span class="decimal">00</span></span> <small>Mens.</small> -->
                        más de&nbsp;<span class="precio">$ 1120 en Beneficios</span>
                    </h2>
                </div>
            </div>
        </div>
    </section>

    <section class="section-beneficios">
        <div class="container">
            <div class="row mb-2 d-flex justify-content-center">
                <div class="col-md-12 col-lg-7">
                    <div class="iframe-container">
                        <!-- <iframe
                            src="https://www.youtube.com/embed/TnYOVlB86KY?autoplay=1&mute=1&playsinline=1"
                            frameborder="0"
                            allow="autoplay; encrypted-media; picture-in-picture"
                            allowfullscreen>
                        </iframe> -->
                        <iframe
                            src="https://www.youtube.com/embed/TnYOVlB86KY?autoplay=1&mute=1&loop=1&playlist=TnYOVlB86KY&playsinline=1"
                            frameborder="0"
                            allow="autoplay; encrypted-media; picture-in-picture"
                            allowfullscreen>
                        </iframe>

                    </div>
                </div>
                @if (isMediumScreen == false) {
                    <div class="col-md-12 col-lg-7">
                        @if (isMediumScreen == false) {
                            <h3>
                                Todo lo que recibes <span>al ser Premium</span>
                            </h3>
                        }
                        <app-beneficios></app-beneficios>
                    </div>
                }
                
            </div>
            @if (isMediumScreen == false) {
                <div class="d-flex justify-content-center align-items-center flex-column mb-5 mt-5">
                    <button (click)="goToPlan()" class="btn custom-button">
                       <span>
                            Sí, quiero todos estos beneficios
                            <img src="assets/images/icons/fluent-premium-filled.webp" alt="arrow right" width="20" height="20">
                       </span>
                    </button>
                </div>
            } @else {
                <div #plan class="mt-4">
                    <app-planes></app-planes>
                </div>
            }

        </div>
    </section>

    <section class="section-valor-real">
        <div class="container">
            <div class="row justify-content-center">
                <h2>
                🎁 Esto es lo que recibes (Valor Real de Mercado)
                </h2>
                <div class="col-md-12 col-lg-7">
                    <ul class="list-group">
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                            1 mentoría personalizada
                            <span>$100</span>
                        </li>
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                            Acceso Masterclass mensuales (12 x $19.99)
                            <span>$239.88</span>
                        </li>
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                            Agente de inteligencia Artificial Financiero 24/7
                            <span>$100</span>
                        </li>
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                            Resumen semanal de mercado (52 informes x $5)
                            <span>$260</span>
                        </li>
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                            Canal WhatsApp estratégico
                            <span>$50</span>
                        </li>
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                            50% descuento en programas
                            <span>$60</span>
                        </li>
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                            3 primeras inversiones en acciones a solo $10.00 comisión
                            <span>$120</span>
                        </li>
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                            3 eBooks exclusivos
                            <span>$90</span>
                        </li>
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                            1 entrada a los encuentros de Networking presencial
                            <span>$100</span>
                        </li>
                    </ul>
                    <div class="box-total">
                        <ul class="list-group">
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                Valor Total Estimado
                                <span>$1119,88</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="section-planes">
        <div class="container">
            <div class="row">
                 @if (isMediumScreen) {
                    <h3 class="pt-5">
                        Todo lo que recibes <span>al ser Premium</span>
                    </h3>
                    <app-beneficios></app-beneficios>
                    <div class="d-flex justify-content-center align-items-center flex-column mb-5 mt-5">
                    <button (click)="goToPlan()" class="btn custom-button">
                    <span>
                            Sí, quiero todos estos beneficios
                            <img src="assets/images/icons/fluent-premium-filled.webp" alt="arrow right" width="20" height="20">
                    </span>
                    </button>
                </div>
                } @else {
                    <div #plan>
                        <app-planes></app-planes>
                    </div>
                }
            </div>
        </div>
    </section>
   
    <section class="section-marketing">
        <div class="container">
            <div class="row">
                <div class="d-flex justify-content-center my-3">
                    <img src="assets/images/icons/fluent-premium-filled-l.webp" alt="arrow right" width="50" height="50">
                </div>
                <h2>
                    Invertir sin guía es costoso.<br>
                    Ser Premium te da claridad, estrategia y comunidad.
                </h2>
            </div>
        </div>

    </section>

    <section class="section-razon">
        <div class="container">
            <h2>
                3 Razones por las que nuestros miembros eligen ser Premium
            </h2>
            <div class="row d-flex justify-content-center">
                <div class="col-lg-6 container-razon-content">
                    <div class="container-razon">
                        <b>1</b>
                        <div class="container-razon-info">
                            <strong>Aprende con expertos</strong>
                            <p>Contenido claro y práctico</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 container-razon-content">
                    <div class="container-razon">
                        <b>2</b>
                        <div class="container-razon-info">
                            <strong>Invierte con Respaldo</strong>
                            <p>Asesoría validada y profesional</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 container-razon-content">
                    <div class="container-razon">
                        <b>3</b>
                        <div class="container-razon-info">
                            <strong>Maximiza tu rentabilidad</strong>
                            <p>Educación + tecnología + comunidad</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-center align-items-center flex-column">
                <button (click)="goToPlan()" class="btn custom-button">
                   <span>
                        Si, quiero empezar hoy mismo
                        <img src="assets/images/icons/fluent-premium-filled.webp" alt="arrow right" width="20" height="20">
                   </span>
                </button>
            </div>
        </div>
    </section>

    <section class="section-comments">
        <div class="container">
            <div class="row">
                <h2>
                    Lo que han logrado nuestros Clientes
                </h2>
            </div>
            <div class="row">
                <div id="carouselCommentsIndicators" class="carousel slide" data-bs-ride="carousel" data-bs-interval="5000">
                    <div class="carousel-indicators">
                        <button type="button" data-bs-target="#carouselCommentsIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                        <button type="button" data-bs-target="#carouselCommentsIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                    </div>
                    <div class="carousel-inner">
                        <div class="carousel-item active">
                            <div class="row">
                                <div class="col-md-12 col-lg-4 d-flex justify-content-center">
                                    <div class="comment">
                                        <img src="assets/images/icons/quotes.webp" width="39" height="29" alt="Quotes Icon">
                                        <p>
                                            En lo personal, estoy muy agradecida. Me llevo un conocimiento amplio que realmente
                                            necesitaba. Además, me siento feliz y orgullosa de ser parte de esta comunidad, algo
                                            que tiene un gran valor para mí.
                                        </p>
                                        <div class="profile">
                                            <figure>
                                                <img src="assets/images/personas/katty.png" alt="Profile Image" width="47" height="47">
                                            </figure>
                                            <div class="calification">
                                                <p>
                                                    Katty Contreras
                                                </p>
                                                <span class="stars">
                                                    <i class="fa fa-star"></i>    
                                                    <i class="fa fa-star"></i>    
                                                    <i class="fa fa-star"></i>    
                                                    <i class="fa fa-star"></i>    
                                                    <i class="fa fa-star"></i>    
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12 col-lg-4 d-flex justify-content-center">
                                    <div class="comment">
                                        <img src="assets/images/icons/quotes.webp" width="39" height="29" alt="Quotes Icon">
                                        <p>
                                            Mil gracias por los amplios conocimientos que nos han compartido. Estoy muy
                                            agradecida por hacerme parte de este grupo tan valioso dentro de su comunidad.
                                        </p>
                                        <div class="profile">
                                            <figure>
                                                <img src="assets/images/personas/mercy.png" alt="Profile Image" width="47" height="47">
                                            </figure>
                                            <div class="calification">
                                                <p>
                                                    Mercy Aldeón
                                                </p>
                                                <span class="stars">
                                                    <i class="fa fa-star"></i>    
                                                    <i class="fa fa-star"></i>    
                                                    <i class="fa fa-star"></i>    
                                                    <i class="fa fa-star"></i>    
                                                    <i class="fa fa-star"></i>    
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12 col-lg-4 d-flex justify-content-center">
                                    <div class="comment">
                                        <img src="assets/images/icons/quotes.webp" width="39" height="29" alt="Quotes Icon">
                                        <p>
                                            Gracias por la valiosa información. Este curso me dio más conocimiento y me ayudó a
                                            perder el miedo a invertir. Ahora tengo mayor seguridad y confianza para tomar
                                            decisiones financieras
                                        </p>
                                        <div class="profile">
                                            <figure>
                                                <img src="assets/images/personas/sebastian.png" alt="Profile Image" width="47" height="47">
                                            </figure>
                                            <div class="calification">
                                                <p>
                                                    Sebastián Díaz
                                                </p>
                                                <span class="stars">
                                                    <i class="fa fa-star"></i>    
                                                    <i class="fa fa-star"></i>    
                                                    <i class="fa fa-star"></i>    
                                                    <i class="fa fa-star"></i>    
                                                    <i class="fa fa-star"></i>    
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                       <div class="carousel-item">
                            <div class="row">
                                <div class="col-md-12 col-lg-4 d-flex justify-content-center">
                                    <div class="comment">
                                        <img src="assets/images/icons/quotes.webp" width="39" height="29" alt="Quotes Icon">
                                        <p>
                                            Este curso aclaró mis dudas sobre la rentabilidad variable y las acciones, ya que, por lo
                                            general, desconocemos cómo funciona el mercado de valores.
                                        </p>
                                        <div class="profile">
                                            <figure>
                                                <img src="assets/images/personas/andres.png" alt="Profile Image" width="47" height="47">
                                            </figure>
                                            <div class="calification">
                                                <p>
                                                    Andrés Celi
                                                </p>
                                                <span class="stars">
                                                    <i class="fa fa-star"></i>    
                                                    <i class="fa fa-star"></i>    
                                                    <i class="fa fa-star"></i>    
                                                    <i class="fa fa-star"></i>    
                                                    <i class="fa fa-star"></i>    
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12 col-lg-4 d-flex justify-content-center">
                                    <div class="comment">
                                        <img src="assets/images/icons/quotes.webp" width="39" height="29" alt="Quotes Icon">
                                        <p>
                                            Estoy muy agradecido, ya que este espacio me permitió aclarar mis dudas y conocer
                                            mejores opciones de inversión. La mayoría solo conocemos las inversiones bancarias,
                                            pero ahora tengo una visión más clara y amplia.
                                        </p>
                                        <div class="profile">
                                            <figure>
                                                <img src="assets/images/personas/wilmer.png" alt="Profile Image" width="47" height="47">
                                            </figure>
                                            <div class="calification">
                                                <p>
                                                    Wilmer Gaspar
                                                </p>
                                                <span class="stars">
                                                    <i class="fa fa-star"></i>    
                                                    <i class="fa fa-star"></i>    
                                                    <i class="fa fa-star"></i>    
                                                    <i class="fa fa-star"></i>    
                                                    <i class="fa fa-star"></i>    
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12 col-lg-4 d-flex justify-content-center">
                                    <div class="comment">
                                        <img src="assets/images/icons/quotes.webp" width="39" height="29" alt="Quotes Icon">
                                        <p>
                                            Excelente. Toda la información compartida ha sido muy valiosa para avanzar en mi
                                            camino hacia la libertad financiera.
                                        </p>
                                        <div class="profile">
                                            <figure>
                                                <img src="assets/images/personas/nelson.png" alt="Profile Image" width="47" height="47">
                                            </figure>
                                            <div class="calification">
                                                <p>
                                                    Nelson Moreno
                                                </p>
                                                <span class="stars">
                                                    <i class="fa fa-star"></i>    
                                                    <i class="fa fa-star"></i>    
                                                    <i class="fa fa-star"></i>    
                                                    <i class="fa fa-star"></i>    
                                                    <i class="fa fa-star"></i>    
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container-button">
                <button (click)="goToPlan()" class="btn custom-button">
                   <span>
                        Yo quiero vivir esta experiencia Premium
                        <img src="assets/images/icons/fluent-premium-filled.webp" alt="arrow right" width="20" height="20">
                   </span>
                </button>
            </div>
        </div>
    </section>

    <section class="section-beneficios-cards">
        <div class="container">
            <div class="row d-flex justify-content-center">
                <h2>
                    Beneficios de ser Premium
                </h2>
                <div class="container-box">
                    <div *ngFor="let beneficio of beneficios; let i = index" class="box">
                        <strong>{{ beneficio.title }}</strong>
                        <ul>
                            <li *ngFor="let item of beneficio.items; let y = index" >
                                <div class="box-icon">
                                    <img src="assets/images/icons/crown-xs.png" alt="arrow right" width="10" height="10">
                                </div>
                                <span>{{ item }}</span>
                            </li>
                        </ul>
                    </div>
               
                </div>

                <!-- <div>
                    <div id="amoforms-target"></div>
                </div> -->
                <!-- <div class="container-form">
                    <div id="amoforms_container_1427027"></div>
                    <iframe
                        src="https://forms.kommo.com/forms/assets/js/amoforms.js?1767196058"
                        width="100%"
                        height="700"
                        style="border:none">
                    </iframe>
                </div> -->

            </div>
        </div>
    </section>

    <section class="section-questions">
        <div class="container">
            <div class="row">
                <div class=" text-center  col-lg-12 mb-5">
                    <h2>
                        Preguntas Frecuentes
                    </h2>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 col-lg-12">
                    <div class="accordion" id="faq1">
                        <div class="row">
                            <div class="col-md-12 col-lg-6">
                                <!-- Pregunta 1 -->
                                <article class="accordion-item">
                                    <div class="accordion-header" id="panelsStayOpen-headingOne">
                                        <button 
                                            class="accordion-button collapsed" 
                                            type="button" 
                                            data-bs-toggle="collapse" 
                                            data-bs-target="#panelsStayOpen-collapseOne" 
                                            aria-expanded="false" 
                                            aria-controls="panelsStayOpen-collapseOne">
                                            <strong>¿Cuál es la diferencia entre BÁSICO, PREMIUM y DIAMANTE? 🤔</strong>
                                        </button>
                                    </div>
                                    <div 
                                        id="panelsStayOpen-collapseOne" 
                                        class="accordion-collapse collapse" 
                                        aria-labelledby="panelsStayOpen-headingOne">
                                        <div class="accordion-body">
                                            <ul>
                                                <li>
                                                    <span><strong>BÁSICO (USD 80): </strong> 1 asesoría, 2 eBooks, 25% OFF en cursos.</span>
                                                </li>
                                                <li>
                                                    <span><strong>PREMIUM (USD 99.99): </strong> ✅ Asesorías ilimitadas, 2 mentorías, masterclasses mensuales, GPT AI, WhatsApp VIP, descuentos mayores y eventos. (Nuestro top ventas)</span>
                                                </li>
                                                <li>
                                                    <span><strong>DIAMANTE (USD 200): </strong> Todo lo de Premium + 3 eBooks, Summit 2026 GRATIS y networking VIP.</span>
                                                </li>
                                            </ul>
                                            <p class="text-italic">
                                                👉 Si buscas el balance perfecto entre inversión y beneficios, elige PREMIUM.
                                            </p>
                                        </div>
                                    </div>
                                </article>
                            </div>
                            <div class="col-md-12 col-lg-6">
                                <!-- Pregunta 2 -->
                                <article class="accordion-item">
                                    <div class="accordion-header" id="panelsStayOpen-headingTwo">
                                        <button 
                                            class="accordion-button collapsed" 
                                            type="button" 
                                            data-bs-toggle="collapse" 
                                            data-bs-target="#panelsStayOpen-collapseTwo" 
                                            aria-expanded="false" 
                                            aria-controls="panelsStayOpen-collapseTwo">
                                            <strong>¿Necesito solo una asesoría puntual o prefiero acompañamiento continuo? 👩‍💼</strong>
                                        </button>
                                    </div>
                                    <div 
                                        id="panelsStayOpen-collapseTwo" 
                                        class="accordion-collapse collapse" 
                                        aria-labelledby="panelsStayOpen-headingTwo">
                                        <div class="accordion-body">
                                            <ul>
                                                <li>
                                                    <span>Con <strong>BÁSICO</strong> tienes 1 sesión.</span>
                                                </li>
                                                <li>
                                                    <span>Con <strong>PREMIUM</strong> hablas con nuestros expertos tantas veces como quieras.</span>
                                                </li>
                                                <li>
                                                    <span>Con <strong>DIAMANTE</strong> igual que Premium, ¡pero con extras VIP!</span>
                                                </li>
                                            </ul>
                                            <p class="text-italic">
                                                Para asegurarte de no quedarte con dudas, Premium es la opción ideal.
                                            </p>
                                        </div>
                                    </div>
                                </article>
                            </div>

                            <div class="col-md-12 col-lg-6">
                                <!-- Pregunta 3 -->
                                <article class="accordion-item">
                                    <div class="accordion-header" id="panelsStayOpen-headingThree">
                                        <button 
                                            class="accordion-button collapsed" 
                                            type="button" 
                                            data-bs-toggle="collapse" 
                                            data-bs-target="#panelsStayOpen-collapseThree" 
                                            aria-expanded="false" 
                                            aria-controls="panelsStayOpen-collapseThree">
                                            <strong>¿Vale la pena pagar USD 99.99 en lugar de USD 80? 🎓</strong>
                                        </button>
                                    </div>
                                    <div 
                                        id="panelsStayOpen-collapseThree" 
                                        class="accordion-collapse collapse" 
                                        aria-labelledby="panelsStayOpen-headingThree">
                                        <div class="accordion-body">
                                            <p>Por solo USD 19.99 más:</p>
                                            <ul>
                                                <li>
                                                    <span>Asesorías<strong> ilimitadas </strong> vs. 1 sola.</span>
                                                </li>
                                                <li>
                                                    <span>Masterclasses exclusivas, GPT AI y WhatsApp con tips.</span>
                                                </li>
                                                <li>
                                                    <span>50% OFF en cursos vs. 25% OFF en Básico.</span>
                                                </li>
                                            </ul>
                                            <p class="text-italic">
                                                Esa pequeña inversión extra se recupera rápido con los beneficios Premium.
                                            </p>
                                        </div>
                                    </div>
                                </article>
                            </div>

                            <div class="col-md-12 col-lg-6">
                                <!-- Pregunta 4 -->
                                <article class="accordion-item">
                                    <div class="accordion-header" id="panelsStayOpen-headingFour">
                                        <button 
                                            class="accordion-button collapsed" 
                                            type="button" 
                                            data-bs-toggle="collapse" 
                                            data-bs-target="#panelsStayOpen-collapseFour" 
                                            aria-expanded="false" 
                                            aria-controls="panelsStayOpen-collapseFour">
                                            <strong>¿Cómo ahorro con cada plan? 💸</strong>
                                        </button>
                                    </div>
                                    <div 
                                        id="panelsStayOpen-collapseFour" 
                                        class="accordion-collapse collapse" 
                                        aria-labelledby="panelsStayOpen-headingFour">
                                        <div class="accordion-body">
                                            <ul>
                                                <li>
                                                    <span><strong>BÁSICO:</strong> 25% OFF en todos los programas.</span>
                                                </li>
                                                <li>
                                                    <span><strong>PREMIUM:</strong> 50% OFF + comisión fija de USD 10 en inversiones desde USD 100 + 25% en Summit 2026.</span>
                                                </li>
                                                <li>
                                                    <span><strong>DIAMANTE:</strong> Mismos descuentos que Premium + entrada GRATIS al Summit y networking VIP.</span>
                                                </li>
                                            </ul>
                                            <p class="text-italic">
                                                Con Premium, tus ahorros anuales pueden superar los USD 150.
                                            </p>
                                        </div>
                                    </div>
                                </article>
                            </div>

                            <div class="col-md-12 col-lg-6">
                                <!-- Pregunta 5 -->
                                <article class="accordion-item">
                                    <div class="accordion-header" id="panelsStayOpen-headingFive">
                                        <button 
                                            class="accordion-button collapsed" 
                                            type="button" 
                                            data-bs-toggle="collapse" 
                                            data-bs-target="#panelsStayOpen-collapseFive" 
                                            aria-expanded="false" 
                                            aria-controls="panelsStayOpen-collapseFive">
                                            <strong>¿Qué tan útil es el GPT de Finanzas e Inversiones Futuro? 🤖</strong>
                                        </button>
                                    </div>
                                    <div 
                                        id="panelsStayOpen-collapseFive" 
                                        class="accordion-collapse collapse" 
                                        aria-labelledby="panelsStayOpen-headingFive">
                                        <div class="accordion-body">
                                            <span> Disponible solo en <strong>PREMIUM</strong> y <strong>DIAMANTE</strong>:</span>
                                            <ul>
                                                <li>
                                                    <span>Responde tus preguntas de inversión al instante.</span>
                                                </li>
                                                <li>
                                                    <span>Simula escenarios y te guía en análisis de acciones.</span>
                                                </li>
                                            </ul>
                                            <p class="text-italic">
                                                Es como tener un analista personal las 24 horas.
                                            </p>
                                        </div>
                                    </div>
                                </article>
                            </div>

                            <div class="col-md-12 col-lg-6">
                                <!-- Pregunta 6 -->
                                <article class="accordion-item">
                                    <div class="accordion-header" id="panelsStayOpen-headingSix">
                                        <button 
                                        class="accordion-button collapsed" 
                                        type="button" 
                                        data-bs-toggle="collapse" 
                                        data-bs-target="#panelsStayOpen-collapseSix" 
                                        aria-expanded="false" 
                                        aria-controls="panelsStayOpen-collapseSix">
                                            <strong>¿Puedo aprender si tengo poco tiempo? 📅</strong>
                                        </button>
                                    </div>
                                    <div 
                                        id="panelsStayOpen-collapseSix" 
                                        class="accordion-collapse collapse" 
                                        aria-labelledby="panelsStayOpen-headingSix">
                                        <div class="accordion-body">
                                            <ul>
                                                <li>
                                                    <span><strong>PREMIUM y DIAMANTE </strong>incluyen:</span>
                                                    <ul>
                                                        <li>
                                                            <span><strong>Tips</strong> todos los lunes por WhatsApp.</span>
                                                        </li>
                                                        <li>
                                                            <span>Acceso on‑demand a <strong>YouTube y podcast</strong></span>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                            <p class="text-italic">
                                                Tu formación llega a tu agenda, sin excusas.
                                            </p>
                                        </div>
                                    </div>
                                </article>
                            </div>

                            <div class="col-md-12 col-lg-6">
                                <!-- Pregunta 7 -->
                                <article class="accordion-item">
                                    <div class="accordion-header" id="panelsStayOpen-headingSeven">
                                        <button 
                                        class="accordion-button collapsed" 
                                        type="button" 
                                        data-bs-toggle="collapse" 
                                        data-bs-target="#panelsStayOpen-collapseSeven" 
                                        aria-expanded="false" 
                                        aria-controls="panelsStayOpen-collapseSeven">
                                            <strong>¿Qué beneficios de networking ofrecen los planes? 🤝</strong>
                                        </button>
                                    </div>
                                    <div 
                                        id="panelsStayOpen-collapseSeven" 
                                        class="accordion-collapse collapse" 
                                        aria-labelledby="panelsStayOpen-headingSeven">
                                        <div class="accordion-body">
                                            <ul>
                                                <li>
                                                    <span><strong>PREMIUM:</strong> Descuento 25% en el Summit Financiero 2026.</span>
                                                </li>
                                                <li>
                                                    <span><strong>DIAMANTE:</strong> Entrada gratuita + <strong>espacio VIP</strong> para conectar con inversionistas élite.</span>
                                                </li>
                                            </ul>
                                            <p class="text-italic">
                                                Premium te acerca al evento con ahorro; Diamante te da la experiencia completa.
                                            </p>
                                        </div>
                                    </div>
                                </article>
                            </div>

                            <div class="col-md-12 col-lg-6">
                                <!-- Pregunta 8 -->
                                <article class="accordion-item">
                                    <div class="accordion-header" id="panelsStayOpen-headingEight">
                                        <button 
                                        class="accordion-button collapsed" 
                                        type="button" 
                                        data-bs-toggle="collapse" 
                                        data-bs-target="#panelsStayOpen-collapseEight" 
                                        aria-expanded="false" 
                                        aria-controls="panelsStayOpen-collapseEight">
                                            <strong>¿Cómo empiezo con el Plan Premium? 📈</strong>
                                        </button>
                                    </div>
                                    <div 
                                        id="panelsStayOpen-collapseEight" 
                                        class="accordion-collapse collapse" 
                                        aria-labelledby="panelsStayOpen-headingEight">
                                        <div class="accordion-body">
                                            <p>1. Haz clic en el botón.</p>
                                            <p>2. Completa tu pago seguro de USD 99.99.</p>
                                            <p>3. Recibe acceso inmediato a todo el contenido y canales exclusivos.</p>
                                            <div>
                                                <p class="text-link"><a href="https://wa.link/63cnhb" target="_blank">🔗  Activar Plan Premium – USD 99.99</a></p>
                                                <p class="text-italic">¡Únete a la comunidad que más crece y convierte tu inversión en resultados!</p>
                                            </div>
                                        </div>
                                    </div>
                                </article>
                            </div>
                        </div>
                    </div>
                 
                </div>
            </div>
            
            <div class="row mt-5">
                <div class="box">
                    <h2>
                        Tu Futuro financiero empieza hoy
                    </h2>
                    <h4>
                        desde&nbsp;<span>$ 0.30</span>&nbsp;diarios.
                    </h4>
                    <p>
                        Accede a asesoría, mentoría, educación exclusiva y herramientas que realmente te ayudarán a crecer como inversionista.
                    </p>

                    <button (click)="goToPlan()" target="_blank" class="btn custom-button-secondary">
                        <span>
                            Quiero ser Premium ahora
                            <img src="assets/images/icons/fluent-premium.webp" alt="arrow right" width="20" height="20">
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </section>

</main>

<app-chat-support></app-chat-support>